
export enum EAdministrativeFormType {
    FACT_A = 'FACTURA A',
    FACT_B = 'FACTURA B',
    FACT_C = 'FACTURA C',
    NCRED_A = 'NOTA DE CRÉDITO A',
    NCRED_B = 'NOTA DE CRÉDITO B',
    NCRED_C = 'NOTA DE CRÉDITO C',
    RECIBO = 'RECIBO',
    NDEB_A = 'NOTA DE DÉBITO A',
    NDEB_B = 'NOTA DE DÉBITO B',
    NDEB_C = 'NOTA DE DÉBITO C',
    FCE_A = 'FCE MiPyMEs A',
    FCE_B = 'FCE MiPyMEs B',
    FCE_C = 'FCE MiPyMEs C',
    NCE_A = 'NOTA CRÉDITO MiPyMEs A',
    NCE_B = 'NOTA CRÉDITO MiPyMEs B',
    NCE_C = 'NOTA CRÉDITO MiPyMEs C',
    NDE_A = 'NOTA DÉBITO MiPyMEs A',
    NDE_B = 'NOTA DÉBITO MiPyMEs B',
    NDE_C = 'NOTA DÉBITO MiPyMEs C',

}

export const EAdministrativeFormTypeValues: { [key in EAdministrativeFormType]: number } = {
    [EAdministrativeFormType.FACT_A]: 1,
    [EAdministrativeFormType.FACT_B]: 2,
    [EAdministrativeFormType.FACT_C]: 3,
    [EAdministrativeFormType.NCRED_A]: 21,
    [EAdministrativeFormType.NCRED_B]: 22,
    [EAdministrativeFormType.NCRED_C]: 23,
    [EAdministrativeFormType.RECIBO]: 31,
    [EAdministrativeFormType.NDEB_A]: 41,
    [EAdministrativeFormType.NDEB_B]: 42,
    [EAdministrativeFormType.NDEB_C]: 43,
    [EAdministrativeFormType.FCE_A]: 83,
    [EAdministrativeFormType.FCE_B]: 84,
    [EAdministrativeFormType.FCE_C]: 85,
    [EAdministrativeFormType.NCE_A]: 86,
    [EAdministrativeFormType.NCE_B]: 87,
    [EAdministrativeFormType.NCE_C]: 88,
    [EAdministrativeFormType.NDE_A]: 89,
    [EAdministrativeFormType.NDE_B]: 90,
    [EAdministrativeFormType.NDE_C]: 91,
}

export const creditNotes = [EAdministrativeFormTypeValues[EAdministrativeFormType.NCRED_A], EAdministrativeFormTypeValues[EAdministrativeFormType.NCRED_B], EAdministrativeFormTypeValues[EAdministrativeFormType.NCRED_C]]